export default {
  edit: 'Edit',
  delete: 'Delete',
  detail: 'Detail',
  deleteThisImage: 'Delete this image',
};
